
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"545","height":"175","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0v156.075c37.518 12.006 83.078 19.568 139 18.882 69.902-.858 192.62-30.017 272-31.732 63.504-1.373 134 12.85 134 12.85V0H0z","fill":"url(#paint0_linear_4794_3)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_4794_3","x1":"-76","y1":"183.533","x2":"518.831","y2":"-49.345","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#5B46D9"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#DC50BC"}})])])])
          )
        }
      }
    